<template>
  <div class="tags-container">
    <div class="others">
      <div class="container_media">
        <div class="tag-row picture-scene">
          <div class="title">场景：</div>
          <div class="tags-wrap">
            <span
              v-for="(item, idx) in pictureFilterTag"
              :key="`scene_${idx}`"
              :class="{ active_label: currentTag === idx }"
              @click="changeTag(idx, item)"
            >{{ item.label_name }}</span>
          </div>
        </div>
        <div class="tag-row" v-if="sceneList.length">
          <div class="title">用途：</div>
          <div class="tags-wrap">
            <span
              v-for="(item, idx) in sceneList"
              :key="`use_${idx}`"
              :class="{ active_label: currentScene === item.label_id }"
              @click="changeScene(item)"
            >{{ item.name }}</span>
          </div>
        </div>
        <div class="tag-sort-box picture-sort">
          <div class="tag_sort rowShow">
            <div class="tag_sort_title">排序：</div>
            <div class="tag_sort_content">
              <span
                v-for="(m, i) in sortList"
                :key="i"
                :class="{ active_label: m.value === currentSort }"
                @click="setSort(m.value)"
              >{{ m.label }}</span>
            </div>
          </div>
          <div class="tag_sort direction-row">
            <div class="tag_sort_title">方向：</div>
            <div class="tag_sort_content">
              <span
                v-for="(m, i) in directionList"
                :key="`dir_${i}`"
                :class="{ active_label: m.value === currentDirection }"
                @click="changeDirection(m)"
              >{{ m.label }}</span>
            </div>
          </div>
          <div class="tag-pagina">
            <i class="pagina_l el-icon-arrow-left" :class="{ active: lpage }" @click="prevPage"></i>
            <span class="pager">
              <i class="page">{{ pager.page }}</i>
              <i class="pagesize">/{{ pages || '...' }}</i>
            </span>
            <i class="pagina_r el-icon-arrow-right" :class="{ active: rpage }" @click="nextPage"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fetchPictureLabel } from '@/api/picture'

export default {
  name: 'SearchPictureTagsFilter',
  props: {
    pager: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      pictureFilterTag: [],
      sceneList: [],
      currentTag: 0,
      currentScene: '',
      currentSort: '',
      currentDirection: '',
      argList: [],
      lpage: false,
      rpage: false,
      sortList: [
        { label: '综合', value: '' },
        { label: '最新', value: '1' },
        { label: '最热', value: '2' }
      ],
      directionList: [
        { label: '全部', value: '' },
        { label: '横版', value: '1' },
        { label: '竖版', value: '2' }
      ]
    }
  },
  computed: {
    pages() {
      if (!this.pager.limit) return 0
      return Math.ceil(this.pager.total / this.pager.limit)
    }
  },
  created() {
    this.loadTags()
  },
  methods: {
    async loadTags() {
      try {
        const res = await fetchPictureLabel()
        if (res.code === 0) {
          this.pictureFilterTag = [
            {
              label_id: '',
              son: [],
              label_name: '全部'
            },
            ...(res.data || [])
          ]
          this.currentTag = 0
          this.sceneList = []
          this.argList = []
        }
      } catch (e) {
        console.error(e)
      }
    },
    getLabelIds(list = []) {
      if (!Array.isArray(list)) {
        return list || ''
      }
      if (list.length > 1) {
        const idList = []
        list.forEach((m) => {
          if (m && m.label_id) {
            idList.push(m.label_id)
          }
        })
        return idList.join(',')
      }
      const first = list[0]
      return (first && first.label_id) || first || ''
    },
    emitChange() {
      this.$emit('change', {
        label_id: this.getLabelIds(this.argList),
        order: this.currentSort,
        pattern: this.currentDirection
      })
    },
    changeTag(i, item) {
      this.currentTag = i
      this.currentScene = ''
      let list = []
      if (item.label_id) {
        list = [{ name: '全部', label_id: '' }, ...(item.son || [])]
      }
      this.sceneList = list
      this.argList = list
      this.emitChange()
    },
    changeScene(item) {
      this.currentScene = item.label_id
      this.argList = item.label_id ? [item.label_id] : this.sceneList
      this.emitChange()
    },
    setSort(v) {
      this.currentSort = v
      this.emitChange()
    },
    changeDirection(item) {
      this.currentDirection = item.value
      this.emitChange()
    },
    prevPage() {
      if (this.pager.page < 2) return
      this.$emit('pageChange', { page: this.pager.page - 1 })
      this.lpage = true
      this.rpage = false
    },
    nextPage() {
      if (this.pager.page < this.pages) {
        this.$emit('pageChange', { page: this.pager.page + 1 })
        this.lpage = false
        this.rpage = true
      }
    },
    cleanTagSearch() {
      this.currentTag = 0
      this.currentScene = ''
      this.currentSort = ''
      this.currentDirection = ''
      if (this.pictureFilterTag.length) {
        this.changeTag(0, this.pictureFilterTag[0])
      } else {
        this.argList = []
        this.sceneList = []
        this.emitChange()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './tags-filter-shell.scss';

.picture-sort {
  flex-wrap: wrap;
  gap: 8px 0;

  .rowShow,
  .direction-row {
    display: flex;
    align-items: center;
    margin-right: 24px;
  }

  .tag-pagina {
    position: static;
    margin-left: auto;
  }
}
</style>
